module.exports = __webpack_public_path__ + "img/value-blocks-slider-mitsu.7fa13832.png";